import axios from "axios";

export interface ContactFormData {
    name: string;
    email: string;
    subject: string;
    message: string;
}

export interface ContactFormResponse {
    success: boolean;
    message: string;
}

export const submitContactForm = async (formData: ContactFormData): Promise<ContactFormResponse> => {
    const { name, email, subject, message } = formData;
    const response = await axios.post("/api/contact/email", {
        name,
        email,
        subject,
        message,
    });
    return response.data;
};

